<script>
  import { Logo } from "$lib/components";
  import MenuIcon from "$lib/assets/icons/menu.svg";
  import { goto } from "$app/navigation";
  import { Footer } from "$lib/components";

  export let data;
  let size = "sm";
  let showMenu = false;

  function toggleNavbar() {
    showMenu = !showMenu;
  }
</script>

<div class="bg-shade-white min-h-screen">
  <!-- Navbar -->
  <nav
    class="w-full border-b border-gray-100 bg-white/80 backdrop-blur-sm sticky top-0 z-50"
  >
    <div
      class="container lg:mx-auto py-3 relative md:px-11 px-6 flex items-center justify-between"
    >
      <div class="w-14">
        <Logo {size} />
      </div>
      <div class="flex">
        <div
          class="absolute space-y-5 text-right rounded top-16 sm:top-0 left-0 right-0 bg-white sm:bg-transparent shadow-xl sm:shadow-none sm:space-y-0 px-5 py-4 sm:py-0 w-full sm:w-auto sm:relative sm:flex gap-8 items-center {showMenu
            ? 'block'
            : 'hidden'}"
        >
          <div>
            <button
              on:click={() => goto("/")}
              class="flex items-center gap-2 group hover:opacity-90 transition-opacity focus:outline-none"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 text-green-500"
              >
                <path
                  d="M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M3 6H21"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span
                class="font-medium text-green-500 text-sm border-b-2 border-transparent group-hover:border-green-500 transition-colors"
              >
                Shop With Us
              </span>
            </button>
          </div>
          <a
            href="#pricing"
            class="block sm:inline text-gray-700 hover:text-green-500 font-medium text-sm transition-colors"
            >Pricing</a
          >
          <a
            href="/contact"
            class="block sm:inline text-gray-700 hover:text-green-500 font-medium text-sm transition-colors"
            >Contact</a
          >
          <a
            href="/login"
            class="block sm:inline text-gray-700 hover:text-green-500 font-medium text-sm transition-colors"
            >Login</a
          >
          <div class="py-2 sm:py-0">
            <a class="green-btn-full text-sm" href="/sign-up">Sign Up</a>
          </div>
        </div>
        <!-- Mobile menu button -->
        <button
          on:click={toggleNavbar}
          class="flex sm:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors"
          aria-label="Toggle menu"
        >
          <img src={MenuIcon} alt="Menu" class="w-6 h-6" />
        </button>
      </div>
    </div>
  </nav>

  <!-- Page content -->
  <div class="container lg:mx-auto px-6 md:px-11">
    <slot />
  </div>

  <Footer />
</div>
